import { useTranslation } from 'react-i18next';
import React, {useEffect} from 'react';
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import { Box, Button, Typography } from '@mui/material';
import { useAuth } from '../../context/auth-context';
import { useNavigate } from 'react-router-dom';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
function UsernameChange () {
  const { t } = useTranslation();
  const {user} = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!user.nameneu && false) {
      navigate('/');
    }
    // eslint-disable-next-line
  }, []);
  const acceptUserChange = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY.username, user.newname);
    navigate('/', {replace: true});
  }
  return(
    <Page>
      <Layout>
        <Box p={2}>
          <Typography variant="h4">{t("Neuer Benutzername")}</Typography>
        </Box>
        <Box p={1}>
        <Typography variant="body1">{t("Ihr Benutzername hat sich geändert.")}</Typography>
        </Box>
        <Box p={1}>
        <Typography variant="body1" color="error">Alt: {user.oldname} </Typography>
        </Box>
        <Box p={1}>
        <Typography variant="body1" color="secondary">Neu: {user.newname}</Typography>
        </Box>
        <Box p={1}>
        <Typography variant="body1">{t("Bitte melden Sie sich in Zukunft mit dem neuen Benutzernamen an.")}</Typography>
        </Box>
        <Box p={1} pb={2} >
          <Button color="primary" onClick={acceptUserChange}>{t("Weiter")}</Button>
        </Box>
      </Layout>
    </Page>)
}

export default UsernameChange;
